import { setMissingContractor } from "../vehicleInformationSlice";
import { useAppDispatch } from "../../../app/hooks";
import { JSX } from "react";

export const MissingContractorPrompt = (): JSX.Element => {
    const dispatch = useAppDispatch();

    const handleContinueWithoutContractor = (): void => {
        dispatch(setMissingContractor(true));
    };

    return (
        <div className="s-appointment__group border-color-primary">
            <h1 className="s-appointment__group__title">
                Staat je verzekeringsmaatschappij er niet tussen?
            </h1>
            <div className="c-form__buttons c-form__buttons--row">
                <button
                    type="button"
                    onClick={handleContinueWithoutContractor}
                    className="c-form__buttons__single--full-width c-form__buttons__single border-color-primary border-color-primary-hover"
                >
                    <span className="font-face-primary">Ga verder</span>
                </button>
            </div>
        </div>
    );
};
